export const maximumQuantity = 999;

export const defaultCookingTime = 15;
